import axios, { extractData } from '@atheneum/api'
import { extendObservable } from 'mobx'

class ClientStore {
  constructor (staticData) {
    extendObservable(this, {
      loading: false,
      error: null,
      client: null,
      office: null,
      account: null,
      parentAccount: null,
      contractsInPlace: null,
      employees: null,
      accountProjectCount: null
    })
  }

  get (id) {
    this.loading = true
    return axios
      .get('/api/client/' + id)
      .then(res => {
        this.client = extractData(res)
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  getOffice (id) {
    this.loading = true
    return axios
      .get('/api/office/' + id)
      .then(res => {
        this.office = extractData(res)
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  getAccount (id, getOtherData) {
    this.loading = true

    return axios
      .get('/api/account/' + id)
      .then(res => {
        this.account = extractData(res)

        if (getOtherData) {
          Promise.all([
            this.getParentAccount(this.account.parentAccountId),
            this.getProjectsCount(id)
          ]).then(responses => {
            this.parentAccount = extractData(responses[0])
            this.accountProjectCount = extractData(
              responses[1]
            ).numberOfProjects
          })
        }
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  getAccountApi = id => axios.get('/api/account/' + id)
  getParentAccount = id => axios.get('/api/parent-account/' + id)
  getContract = id => axios.get('/api/contract/project/' + id)
  getEmployees = () => axios.get('/api/employee?select=true')
  getProjectsCount = id => axios.get(`/api/account/${id}/project-count`)
}

export default ClientStore
